import React, { useState } from "react";
import { Form, Card } from "react-bootstrap";

interface RadioOption {
  id: string;
  title: string;
  description: string;
}

const options: RadioOption[] = [
  {
    id: "everything",
    title: "Everything",
    description: "Subject, body and attachments will be shared with your team.",
  },
  {
    id: "subject-metadata",
    title: "Subject and metadata",
    description: "Subject and metadata will be shared with your team.",
  },
  {
    id: "metadata",
    title: "Metadata",
    description: "Timestamp and participants will be shared with your team.",
  },
];

const VisibilitySection = () => {
  const [selected, setSelected] = useState("everything");

  return (
    <Card className="border-0 shadow-sm mt-2">
      <Card.Body>
        <Form>
          {options.map((option, index) => (
            <div
              key={option.id}
              className={`p-3 rounded ${
                selected === option.id ? "bg-primary bg-opacity-10" : "bg-light"
              } ${index === options.length - 1 ? "mb-0" : "mb-3"}`}
              style={{ cursor: "pointer" }}
              onClick={() => setSelected(option.id)}
            >
              <Form.Check
                type="radio"
                id={option.id}
                checked={selected === option.id}
                onChange={() => setSelected(option.id)}
                label={
                  <div className="ms-2">
                    <h5> {option.title}</h5>
                    <div className="text-muted small">{option.description}</div>
                  </div>
                }
                className="d-flex align-items-start gap-2 mb-0"
              />
            </div>
          ))}
        </Form>
      </Card.Body>
    </Card>
  );
};

export default VisibilitySection;
